import $ from "jquery";

const ROOT = ".js-accordion";
const TRIGGER = ".js-accordion-trigger";
const CONTENT = ".js-accordion-content";

export const accordion = () => {
  const $accordion = $(ROOT);
  const $items = $accordion.find(TRIGGER);

  $items.each(function () {
    const $item = $(this);
    const $content = $item.find(CONTENT).length
      ? $item.find(CONTENT)
      : $item.next();

    $content.hide();

    $item.on("click", (e) => {
      if (e.target.closest("a")) return;
      $item.toggleClass("is-open");
      $content.slideToggle(300);
    });
  });
};
